import React, { Component } from "react";
import {
  Input,
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import * as message from "../../Constants/MessageConstant";
import { connect } from "react-redux";
import {
  reset,
  setDataSourcePayload,
} from "../../reducers/dataSourcePayloadSlice";

class StandalonDS extends Component {
  constructor(props) {
    super(props);
    this.handleSumbit = this.handleSumbit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.IsDisabled = this.IsDisabled.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      orgId: "",
      fields: this.props.AccountEdit === true ? this.props.data : {},
      errors: {},
      modal: false,
      provider: "",
      modalLoader: false,
      errormessage: "",
      errorPopup: false,
      hidden: true,
      isRedirect: false,
      modalAccntAddedPopup: false,
      loader: false,
    };
  }

  toggleShow = () => {
    this.setState({ hidden: !this.state.hidden });
  };
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    //Name
    if (!fields["staticIp"]) {
      formIsValid = false;
      errors["staticIp"] = "IP Address cannot be empty";
    }
    //accountSecret
    if (!fields["userName"]) {
      formIsValid = false;
      errors["userName"] = "User Name cannot be empty";
    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Password cannot be empty";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }
  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({ fields });
  }
  handleStoreSecret(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.checked;
    this.setState({ fields });
  }
  handleSumbit = (e) => {
    e.preventDefault();
    const { accountname, staticIp, userName, password, id, isCPOEnabled } =
      this.state.fields;
    const payload = {
      accountname: accountname,
      staticIp: staticIp,
      userName: userName,
      password: password,
    //   storeSecret: true,
      isEdit: this.props.AccountEdit,
      id: id,
      isCPOEnabled: isCPOEnabled,
    };
    this.setState({ loader: true });

    if (!this.handleValidation()) {
      return;
    }

    this.props.handlePage(3, true);
    this.props.dsAdded(false);

    fetch(Constdata.ADDUPDATE_STANDALON_CONFIG_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ loader: false });
        if (responseJson.success === true) {
          this.props.dsAdded(true);
        } else {
          this.props.dsError({
            modalLoader: false,
            errorPopup: true,
            errormessage: responseJson.message,
            isErrorHeader: true,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });

    this.props.handlePage(3, true);
  };

  IsDisabled = () => {
    const { staticIp, userName, password } = this.state.fields;
    return (
      !staticIp ||
      !userName ||
      !password ||
      this.state.modalLoader ||
      this.state.loader
    );
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push("/");
    }
  };

  render() {
    return (
      <div>
        <div className="container-verf" style={{ width: "100%" }} role="main">
          <div className="account_container ml-0 pl-0">
            <form>
              <div className="form-group">
                <label htmlFor="accountname">
                  Standalon Metrics Data Source Name:
                </label>
                <Input
                  placeholder="Name for this Standalon Data Source"
                  type="text"
                  id="accountname"
                  name="accountname"
                  value={this.state.fields["accountname"]}
                  onChange={this.handleChange.bind(this, "accountname")}
                  disabled={this.props.AccountEdit}
                />
                <span style={{ color: "red" }}>
                  {this.state.errors["accountname"]}
                </span>
              </div>
              <div className="form-group">
                <label htmlFor="staticIp">IP Address:</label>
                <Input
                  placeholder="IP Address"
                  type="text"
                  id="staticIp"
                  name="staticIp"
                  value={this.state.fields["staticIp"]}
                  onChange={this.handleChange.bind(this, "staticIp")}
                  disabled={this.props.AccountEdit}
                />
                <span style={{ color: "red" }}>
                  {this.state.errors["staticIp"]}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="userName">User Name:</label>
                <InputGroup>
                  <Input
                    placeholder="User Name"
                    type={"text"}
                    id="userName"
                    name="userName"
                    value={this.state.fields["userName"]}
                    onChange={this.handleChange.bind(this, "userName")}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {this.state.errors["userName"]}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password:</label>
                <InputGroup>
                  <Input
                    placeholder="Password"
                    type={this.state.hidden ? "password" : "text"}
                    id="password"
                    name="password"
                    value={this.state.fields["password"]}
                    onChange={this.handleChange.bind(this, "password")}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i
                        className="fa fa-eye-slash"
                        onClick={this.toggleShow}
                      ></i>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
                <span style={{ color: "red" }}>
                  {this.state.errors["password"]}
                </span>
              </div>

              <div className="d-flex mt-5">
                <Button
                  className="btn-cancel"
                  onClick={() => this.props.handlePage(1)}
                >
                  Back
                </Button>
                {this.props.forward ? (
                  <Button
                    id="btnaccount_cancel"
                    style={{ width: "initial" }}
                    onClick={() => this.props.handlePage(3)}
                  >
                    Forward
                  </Button>
                ) : null}
                <Button
                  id={this.IsDisabled() ? "PPU_listdisabled" : "PPU-btn"}
                  type="submit"
                  onClick={this.handleSumbit}
                  disabled={this.IsDisabled()}
                >
                  Start Collecting Data
                </Button>
              </div>

              {this.state.loader === true ? (
                <SerraLoader loader="true"></SerraLoader>
              ) : (
                ""
              )}
            </form>
          </div>
          {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
          {this.state.errorPopup === true ? (
            <SerraError
              Errordata={this.state.errormessage}
              ErrorPopup={this.state.errorPopup}
              setErrorMethod={this.setErrorPopupState}
              isError={this.state.isErrorHeader}
              subTitle={this.state.subTitle}
            ></SerraError>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataSourcePayload: state.dataSourcePayload.payload,
    companyDetails: state.companyDetails.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetDataSourcePayload: () => dispatch(reset()),
    setDataSourcePayload: (data) => dispatch(setDataSourcePayload(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StandalonDS);
